module.exports = __webpack_public_path__ + "img/248.e8ad379b.svg";